import { render, staticRenderFns } from "./shareIndex.vue?vue&type=template&id=08524f68&"
import script from "./shareIndex.vue?vue&type=script&lang=js&"
export * from "./shareIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports